var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#101340",
    fillRule: "evenodd",
    d: "M.218 5.772a.802.802 0 0 1 0-1.1L4.473.228a.722.722 0 0 1 1.054 0l4.255 4.444c.29.304.29.796 0 1.1a.722.722 0 0 1-1.053 0L5 1.878 1.271 5.772a.722.722 0 0 1-1.053 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowUp;